import { ErrorToast } from '../utils/Utils';

export const getOptions = (options) => options?.flatMap((o) => o.title).join(',');
export const getAnswer = (options) => options?.find((o) => o.isAnswer === true)?.title;

export const generateEmptyQuestion = () => ({
  title: '',
  type: 'single_select',
  options: [
    { title: '', isAnswer: false },
    { title: '', isAnswer: false },
  ],
});

export const validate = (data) => {
  let invalid = false;

  if (!data?.name || data.name.trim().length === 0) {
    ErrorToast('Enter a quiz name.');
    return true;
  }
  if (data.name.length > 50) {
    ErrorToast('Quiz name character limit is 50.');
    return true;
  }

  if (!data?.duration) {
    ErrorToast('Enter quiz duration.');
    return true;
  }

  if (!data?.numberOfQuestions || Number.isNaN(Number(data.numberOfQuestions))) {
    ErrorToast('Enter a valid number of questions.');
    return true;
  }

  if (!data?.publishDate) {
    ErrorToast('Select a publish date.');
    return true;
  }

  if (!data?.questions || data.questions.length === 0) {
    ErrorToast('At least one question is required.');
    return true;
  }

  if (data?.numberOfQuestions > data?.questions?.length) {
    ErrorToast('Total questions in Step 1 should be less than or equal to the number of questions added in Step 2.');
    return true;
  }

  data.questions.forEach((question, index) => {
    if (invalid) return;

    const qNum = index + 1;

    if (!question.title?.trim()) {
      ErrorToast(`Enter a title for Question ${qNum}.`);
      invalid = true;
      return;
    }

    if (!question.options || question.options.length < 2) {
      ErrorToast(`Question ${qNum} must have at least 2 options.`);
      invalid = true;
      return;
    }

    if (!question.options.some((opt) => opt.isAnswer)) {
      ErrorToast(`Select a correct answer for Question ${qNum}.`);
      invalid = true;
    }
  });

  return invalid;
};

export const validateSeries = (data, thumbnailImg) => {
  if (!data?.name || data.name.trim().length === 0) {
    ErrorToast('Enter a quiz series name.');
    return true;
  }

  if (data.name.length > 50) {
    ErrorToast('Quiz name character limit is 50.');
    return true;
  }

  if (!thumbnailImg && !data?.thumbnail) {
    ErrorToast('Upload a thumbnail image.');
    return true;
  }

  if (!data?.startDate) {
    ErrorToast('Select a start date.');
    return true;
  }

  if (!data?.endDate) {
    ErrorToast('Select an end date.');
    return true;
  }

  if (!data?.plans || data.plans.length === 0) {
    ErrorToast('Select at least one plan.');
    return true;
  }

  if (!data?.partners) {
    ErrorToast('Select a partner.');
    return true;
  }

  if (data?.departmentRoleIds?.length === 0) {
    ErrorToast('Select a department role.');
    return true;
  }

  if (data?.courseCode && !/^[a-zA-Z0-9]*$/.test(data.courseCode)) {
    ErrorToast('Please enter only alphanumeric characters in quiz reporting code field.');
    return true;
  }

  return false;
};

export const checkType = (variable) => {
  if (typeof variable === 'string') {
    return false;
  }
  return true;
};

export const convertToFormData = (data) => {
  const formData = new FormData();

  formData.append('name', data.name || '');
  formData.append('startDate', data.startDate || '');
  formData.append('endDate', data.endDate || '');
  formData.append('visibility', JSON.stringify(data.visibility));

  formData.append('courseCode', data.courseCode || '');

  if (data?.thumbnail && checkType(data?.thumbnail)) {
    formData.append('thumbnail', data?.thumbnail);
  }
  if (Array.isArray(data?.plans)) {
    data.plans.filter((item) => item.value !== '*').forEach((item) => formData.append('planIds', item.value));
  }
  if (data?.departmentRoleIds && Array.isArray(data?.departmentRoleIds)) {
    data?.departmentRoleIds?.forEach((item) => formData.append('departmentRoleIds', item));
  }
  formData.append('rockedNetworkPartnerId', data.partners || '');

  return formData;
};

export const updateArrayState = (prevData, name, value, checked) => {
  const val = parseInt(value, 10);
  const updatedArray = checked ? [...prevData[name], val] : prevData[name]?.filter((item) => item !== val);
  return { ...prevData, [name]: updatedArray };
};

export const getSelectedRoleIds = (departments) => {
  const selectedRoleIds = [];

  departments.forEach((department) => {
    department.roles.forEach((role) => {
      if (role.selected) {
        selectedRoleIds.push(role.id);
      }
    });
  });

  return selectedRoleIds;
};

export const getStatusColor = (status) => {
  let color = '#027A48';

  if (status === 'Yet to start') {
    color = '#DC6803';
  } else if (status === 'Expired' || status === 'Disabled') {
    color = '#D92D20';
  }

  return color;
};
